import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { KiwixiService } from '../../../kiwixi/kiwixi.service';
import { ExaminationService } from '../../../service/examination.service';
import { MaterialService } from '../../../service/material.service';
import { SharedAppState } from '../../../store/app.states';
import { LilateCardComponent } from '../lilate-card.component';

@Component({
  selector: 'app-lilate-card-absent',
  templateUrl: './lilate-card-absent.component.html',
  styleUrls: ['./lilate-card-absent.component.scss']
})
export class LilateCardAbsentComponent extends LilateCardComponent {
  @Input() bloc: string;

  constructor(
    _router: Router,
    materialService: MaterialService,
    translateService: TranslateService,
    kiwixiService: KiwixiService,
    examinationService: ExaminationService,
    store: Store<SharedAppState>
  ) {
    super(
      _router,
      materialService,
      translateService,
      kiwixiService,
      examinationService,
      store
    );
  }

  /**
   * Clé i18n pour la date d'absence, accordée au genre du candidat connecté.
   * female → Absente ; sinon (male / other / null) → Absent.
   */
  get absentDateKey(): string {
    const gender = this.me?.user?.gender;
    if (gender === 'female') {
      return 'lilate-exam.session-content.absent-date.female';
    }
    return 'lilate-exam.session-content.absent-date.male';
  }
}
